import { defineSlotRecipe } from '@chakra-ui/react';

export const ratingSlotRecipe = defineSlotRecipe({
    slots: [
        'container',
        'ratingNumerical',
        'ratingDescription',
        'ratingCount',
        'descriptionContainer',
    ],
    base: {
        container: {
            alignItems: 'center',
            textAlign: 'right',
            flexDirection: 'row-reverse',
            gap: 'gutterWidth',
            justifyContent: 'end',
        },
        ratingNumerical: {
            backgroundColor: 'secondary.solid',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            flex: '0 0 auto',
            height: 8,
            minWidth: 8,
            px: 1,
            fontSize: 'xs',
            alignItems: 'center',
            fontWeight: 'bold',
            borderRadius: 4,
        },
        ratingDescription: {
            fontWeight: 'bold',
            fontSize: 'lg',
            lineHeight: 1,
        },
        ratingCount: {
            fontSize: 'sm',
            color: 'gray.700',
            lineHeight: 1,
        },
        descriptionContainer: {
            gap: 1,
            flexDirection: 'column',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
        },
    },
    variants: {
        variant: {
            hideLabelsOnMobile: {
                descriptionContainer: {
                    alignItems: 'flex-end',
                },
            },

            accommodationTile: {
                container: {
                    flexDirection: {
                        base: 'row',
                        md: 'row-reverse',
                    },
                    justifyContent: {
                        base: 'start',
                        md: 'end',
                    },
                    gap: {
                        base: 1.5,
                        md: 2,
                    },
                },
                ratingNumerical: {},
                ratingDescription: {
                    flexDirection: {
                        base: 'row',
                        md: 'column',
                    },
                    fontSize: {
                        base: 'xs',
                        md: 'sm',
                    },
                    _after: {
                        color: 'gray.700',
                        content: {
                            base: '"\u2022"',
                            md: 'none',
                        },
                        ml: 1,
                        transform: 'scale(1.25)',
                    },
                },
                ratingCount: {
                    fontSize: 'xs',
                },
                descriptionContainer: {
                    alignItems: {
                        base: 'start',
                        md: 'end',
                    },
                    flexDirection: {
                        base: 'row',
                        md: 'column',
                    },
                    flexWrap: {
                        base: 'wrap',
                        md: 'nowrap',
                    },
                    rowGap: {
                        base: 0,
                        md: 1.5,
                    },
                },
            },
        },
    },
});
